import { setShowSingleLineViewRightReadingPaneInternal } from '../mutators/setShowSingleLineWithRightReadingPaneMutator';
import type { MailLayoutOptions } from 'owa-outlook-service-option-store';
import { lazyCreateOrUpdateOptionsForFeature } from 'owa-outlook-service-options';
import { getOptionsForFeature, OwsOptionsFeatureType } from 'owa-outlook-service-option-store';

export function setShowSingleLineWithRightReadingPane(
    useSingleLineMessageListWithRightReadingPane: boolean
): void {
    // Get existing settings on server
    const userOptions = getOptionsForFeature<MailLayoutOptions>(OwsOptionsFeatureType.MailLayout);

    // Update settings on server
    lazyCreateOrUpdateOptionsForFeature.importAndExecute(OwsOptionsFeatureType.MailLayout, {
        ...userOptions,
        useSingleLineMessageListWithRightReadingPane,
    } as MailLayoutOptions);

    // Update store
    setShowSingleLineViewRightReadingPaneInternal(useSingleLineMessageListWithRightReadingPane);
}
